module.exports = __webpack_public_path__ + "static/media/megarill.489553e7.svg";